import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { t } from 'i18next';
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
  North,
  South
} from '@mui/icons-material';
import { Avatar, Grid } from '@mui/material';
import BakeasyLinkButton from '../buttons/BakeasyLinkButton';
import BakeasyCheckbox from '../common/BakeasyCheckbox';
import {
  BLUE_GRAY_50,
  BLUE_GRAY_500,
  GRAY_200,
  GRAY_800,
  GREEN_50,
  RED_50
} from '../../constants/Colors';
import { useAppSelector } from '../../redux_store/reduxStore';
import { getProfileState } from '../../redux_store/slices/GetUserProfileSlice';
import { getCurrency } from '../../utils/commonUtils';
import { useState } from 'react';

interface Data {
  id: number;
  name: string;
  emailId: string;
  mobile: string;
  status: JSX.Element;
  actions: JSX.Element[];
  storeId: string;
  storeName: string;
  supplierName: string;
  addressCity: string;
  tag: string;
  price: string;
  category: string;
  subCategory: string;
  orderId: string;
  totalPrice: string;
  expectedDate: string;
  deliveryDate: string;
  description: string;
  categoryName: string;
  ingredientName: string;
  units: number;
  nutritionName: string;
  dailyvalue: number;
  measureType: any;
  subCategoryName: string;
  totalRequired: number;
  dateToBeDelivered: string;
  deliveryID: string;
  billID: string;
  billDate: string;
  productName: string;
  quantity: string;
  quantitySent: string;
  backOrder: string;
  contact: string;
  dateCreated: string;
  lastAccess: string;
  products: string;
  edit: string;
  totalOrder: number;
  totalOrderValue: string;
  productType: string;
  recipeBuilder: string;
  orderDate: string;
  dueDate: string;
  unit: string;
}

export interface HeadCell {
  disablePadding?: boolean;
  id: keyof Data | string;
  label: string | any;
  numeric?: boolean | false;
  isChip?: boolean | false;
  sort?: boolean | false;
  align?: string | 'left';
  width?: any;
  disabled?: boolean | false;
}

interface BakeasyTableMainProps {
  headers?: any[];
  headCells?: any[];
  tableData: any;
  navigate?: any;
  count?: any;
  refreshPage?: any;
  rowProps?: number;
  pageNo?: number;
  refreshPageData?: any;
  sortBy?: any;
  sortDirection?: any;
  search?: any;
  filterBy?: any;
  handleCheckChanged?: any;
  filter?: any;
}

const BakeasyTable = React.forwardRef(
  (
    props: BakeasyTableMainProps,
    ref: React.ForwardedRef<{
      handleChangePage: (event: unknown, newPage: number) => void;
    }>
  ) => {
    const {
      headers,
      tableData,
      count,
      refreshPageData,
      pageNo,
      search,
      handleCheckChanged,
      filter
    } = props;
    const [order, setOrder] = useState<number>(filter?.sortDirection ?? -1);
    const [orderBy, setOrderBy] = useState<string>(filter?.sortBy ?? '');
    const [tableDataList, setTableDataList] = useState<any>([]);
    const [page, setPage] = useState(pageNo ?? 0);
    const [mouseOver, setMouseOver] = useState<string>('');
    const [selectAll, setSelectAll] = useState(false);

    let _userProfile: any = useAppSelector(getProfileState);

    React.useImperativeHandle(ref, () => ({
      handleChangePage
    }));

    const handleChangePage = (event: unknown, newPage: number) => {
      setSelectAll(false);
      setPage(newPage);
      refreshPageData(newPage, search, filter);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectAll(false);
      setPage(0);
      let newFilter: any = {
        ...filter,
        limit: Number(event.target.value)
      };

      refreshPageData(0, search, newFilter);
    };

    React.useEffect(() => {
      setTableDataList(tableData);
      const allChecked =
        tableData?.length !== 0 && tableData.every((item: any) => item.productChecked === true);
      setSelectAll(allChecked);
    }, [tableData]);

    function handleCheckBox(row: any, checked: boolean) {
      let newRow = row;
      if (checked) {
        newRow = tableDataList.find((item: any) => item._id === row._id);
      }
      newRow.productChecked = checked;

      const allChecked = tableDataList.every((item: any) => item.productChecked === true);
      if (allChecked) {
        setSelectAll(true);
      }
      if (checked === false) {
        setSelectAll(false);
      }
      handleCheckChanged([newRow], checked);
    }

    const ArrowIcon = (property: any) => {
      let northColor = 'gray',
        southColor = 'gray';

      if (orderBy === property) {
        if (order === -1) {
          northColor = 'black';
          southColor = 'gray';
        } else if (order === 1) {
          northColor = 'gray';
          southColor = 'black';
        }
      }

      return (
        <Grid
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'Center',
            alignItems: 'Center',
            margin: 0
          }}
        >
          <IconButton size="small" sx={{ color: orderBy === property ? 'black' : 'gray' }}>
            {orderBy === property && order === 1 && <North fontSize="inherit" />}
            {orderBy === property && order === -1 && <South fontSize="inherit" />}
            {mouseOver === property && mouseOver !== orderBy && <North fontSize="inherit" />}
          </IconButton>
        </Grid>
      );
      //   return (
      //     <Grid
      //       style={{
      //         display: 'flex',
      //         flexDirection: 'row',
      //         justifyContent: 'Center',
      //         alignItems: 'Center',
      //         //marginLeft: "4px",
      //         margin: 0
      //       }}
      //     >
      //       <IconButton
      //         size="small"
      //         sx={{ color: northColor }}
      //         onClick={event => {
      //           setOrder(-1);
      //           setOrderBy(property);
      //           setPage(0);
      //           let newFilter: any = {
      //             ...filter,
      //             sortBy: property,
      //             sortDirection: -1
      //           };
      //           refreshPageData(0, search, newFilter);
      //         }}
      //       >
      //         <North fontSize="inherit" />
      //       </IconButton>
      //       <IconButton
      //         size="small"
      //         sx={{ marginLeft: -1.5, color: southColor }}
      //         onClick={event => {
      //           setOrder(1);
      //           setOrderBy(property);
      //           setPage(0);
      //           let newFilter: any = {
      //             ...filter,
      //             sortBy: property,
      //             sortDirection: 1
      //           };
      //           refreshPageData(0, search, newFilter);
      //         }}
      //       >
      //         <South fontSize="inherit" />
      //       </IconButton>
      //     </Grid>
      //   );
    };

    function handleHeaderCheckBox(checked: boolean) {
      setSelectAll(checked);
      const allRows = tableDataList.map((row: any) => {
        return { ...row, productChecked: checked };
      });
      setTableDataList(allRows);
      handleCheckChanged(allRows, checked);
    }

    function CustomTableCell(id: any, row: any) {
      switch (id) {
        case 'categoryName':
          if (row['onCategoryNameClick']) {
            return (
              <BakeasyLinkButton id={id} label={row[id]} onClick={row['onCategoryNameClick']} />
            );
          } else {
            return row[id];
          }
        case 'subCategoryName':
          if (row['onSubCategoryNameClick']) {
            return (
              <BakeasyLinkButton id={id} label={row[id]} onClick={row['onSubCategoryNameClick']} />
            );
          } else {
            return row[id];
          }
        case 'productName':
          if (row['onProductNameClick']) {
            return (
              <BakeasyLinkButton id={id} label={row[id]} onClick={row['onProductNameClick']} />
            );
          } else {
            return row[id];
          }
        case 'name':
          return <BakeasyLinkButton label={row[id]} onClick={row['onNameClick']} />;
        case 'storeName':
          if (row['onStoreNameClick']) {
            return <BakeasyLinkButton id={id} label={row[id]} onClick={row['onStoreNameClick']} />;
          } else {
            return row[id];
          }
        case 'supplierName':
          return <BakeasyLinkButton label={row[id]} onClick={row['onSupplierNameClick']} />;
        case 'contact':
          return <BakeasyLinkButton id={id} label={row[id]} onClick={row['onContactClick']} />;
        case 'products':
          return <BakeasyLinkButton label={row[id]} onClick={row['onProductsClick']} />;
        case 'productID':
          if (row['onProductIDClick']) {
            return <BakeasyLinkButton label={row[id]} onClick={row['onProductIDClick']} />;
          } else {
            return row[id];
          }
        case 'orderId':
          if (row['onOrderIdClick']) {
            return <BakeasyLinkButton id={id} label={row[id]} onClick={row['onOrderIdClick']} />;
          } else {
            return row[id];
          }
        case 'invoiceId':
          return <BakeasyLinkButton label={row[id]} onClick={row['onInvoiceIdClick']} />;
        case 'shippingId':
          return <BakeasyLinkButton label={row[id]} onClick={row['onShippingIdClick']} />;
        case 'assignedProducts':
          return <BakeasyLinkButton label={row[id]} onClick={row['onAssignedProductsClick']} />;
        case 'categoryCheck':
          return (
            <BakeasyCheckbox
              label={''}
              value={row[id]}
              onChange={function(event: React.ChangeEvent<HTMLInputElement>): void {
                handleCheckChanged(row);
              }}
            />
          );
        case 'productChecked':
          return (
            <BakeasyCheckbox
              label={''}
              value={row[id]}
              onChange={function(event: React.ChangeEvent<HTMLInputElement>): void {
                handleCheckBox(row, event.target.checked);
              }}
            />
          );
        case 'productionId':
          if (row['onProductionIdClick']) {
            return <BakeasyLinkButton label={row[id]} onClick={row['onProductionIdClick']} />;
          } else {
            return row[id];
          }
        case 'messageDateTime':
          const dateTime = row[id];
          const date = dateTime.substring(0, 10);
          const time = dateTime.substring(11);
          return (
            <div>
              <div> {date}</div>
              <div style={{ color: GRAY_800, fontSize: '0.8rem' }}>{time}</div>
            </div>
          );
        case 'from':
          if (row['fromStoreLogo']) {
            return (
              <Grid>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar sx={{ width: 24, height: 24, backgroundColor: BLUE_GRAY_500 }}>
                    <img
                      src={row['fromStoreLogo']}
                      //     crossOrigin="anonymous"
                      style={{ width: 21, height: 21, objectFit: 'cover' }}
                    />
                  </Avatar>
                  <span style={{ marginLeft: '4px' }}>{row[id]}</span>
                </div>
              </Grid>
            );
          } else {
            return (
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {row[id]}
              </div>
            );
          }
        case 'subject':
          return (
            <div
              style={{
                //whiteSpace: 'normal',
                wordWrap: 'break-word'
                //overflow: 'hidden' // Optional: Hide overflowing text
              }}
            >
              {row[id]}
            </div>
          );
        // case 'to':
        //   return (
        //     <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        //       {row[id]}
        //     </div>
        //   );
        default:
          //return row[id];
          return (
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {row[id]}
            </div>
          );
      }
    }

    function getHeaderLabel(header: any) {
      switch (header?.id) {
        case 'storeCost':
        case 'ordervalue':
        case 'totalPrice':
        case 'price':
        case 'totalOrderValue':
          return t(header?.label) + getCurrency(_userProfile?.value);
        default:
          return t(header?.label);
      }
    }

    // const [draggedRowIndex, setDraggedRowIndex] = useState(null);

    // // Handle drag start
    // const handleDragStart = (index: any) => {
    //   setDraggedRowIndex(index);
    // };

    // // Handle row drop (reorder the rows)
    // const handleDrop = (index: any) => {
    //   if (draggedRowIndex === index) return;

    //   // Create a copy of rows
    //   const updatedRows: any = [...tableDataList];
    //   const [removed] = updatedRows.splice(draggedRowIndex, 1); // Remove dragged item
    //   updatedRows.splice(index, 0, removed); // Insert dragged item at new position

    //   setTableDataList(updatedRows);
    //   setDraggedRowIndex(null); // Reset dragged item state
    // };

    // // Handle drag over to allow drop
    // const handleDragOver = (e: any) => {
    //   e.preventDefault();
    // };

    return (
      <Box sx={{ width: '100%', mt: 2 }}>
        <Paper sx={{ width: '100%' }}>
          <TableContainer style={{ overflowX: 'auto' }}>
            <Table stickyHeader sx={{ minWidth: 500 }} aria-labelledby="tableTitle">
              <TableHead>
                <TableRow>
                  {headers?.map((header, index) => (
                    <TableCell
                      style={{
                        padding: 10,
                        backgroundColor: GRAY_200,
                        textAlign: header.align,
                        whiteSpace: 'nowrap',
                        width: header?.width ?? 'auto',
                        maxWidth: header?.width ?? 'auto',
                        minWidth: header?.width ?? 'auto'
                        // overflow: 'hidden',
                        // textOverflow: 'ellipsis'
                      }}
                      key={index}
                    >
                      {!header.sort ? (
                        // <Typography style={{ fontWeight: 'bold' }}>{t(header.label)}</Typography>
                        <Typography style={{ fontWeight: 'bold' }}>
                          {getHeaderLabel(header)}
                        </Typography>
                      ) : (
                        <TableSortLabel
                          IconComponent={() => ArrowIcon(header?.id)}
                          onMouseOver={(event: any) => {
                            setMouseOver(header?.id);
                          }}
                          onMouseOut={(event: any) => {
                            setMouseOver('');
                          }}
                          onClick={(event: any) => {
                            let _order = order === 1 && orderBy === header?.id ? -1 : 1;
                            let _orderBy =
                              order === -1 && orderBy === header?.id ? 'createdDate' : header?.id;

                            if (_orderBy === 'createdDate' && orderBy === header?.id) {
                              _order = order === 1 ? -1 : 1;
                            }

                            let newFilter: any = {
                              ...filter,
                              sortBy: _orderBy,
                              sortDirection: _order
                            };
                            setOrder(_order);
                            setOrderBy(_orderBy);
                            setPage(0);
                            refreshPageData(0, search, newFilter);
                          }}
                        >
                          <Typography style={{ fontWeight: 'bold' }}>
                            {getHeaderLabel(header)}
                          </Typography>
                        </TableSortLabel>
                      )}
                      {header.id === 'productChecked' ? (
                        <BakeasyCheckbox
                          label={''}
                          value={selectAll}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            handleHeaderCheckBox(event.target.checked);
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {tableDataList?.map((row: any, index: any) => (
                  <TableRow
                    key={index}
                    // draggable // these 10 lines working but commented
                    // onDragStart={() => handleDragStart(index)} // Mark the row as the dragged item
                    // onDragOver={handleDragOver} // Allow the drop
                    // onDrop={() => handleDrop(index)} // Drop at the new position
                    // hover
                    // style={{
                    //   cursor: 'move',
                    //   backgroundColor: draggedRowIndex === index ? '#f4f4f4' : ''
                    // }} // Highlight dragged row
                    sx={{
                      backgroundColor: (() => {
                        if (row?.highPriority === true) {
                          return RED_50;
                        } else if (row?.status?.props?.label === 'New') {
                          return GREEN_50;
                        } else if (row?.status?.props?.label === 'Split') {
                          return BLUE_GRAY_50;
                        } else if (
                          row?.priority?.props?.label === 'urgent' &&
                          row?.status === 'new'
                        ) {
                          return RED_50;
                        } else if (row?.status === 'new') {
                          return GREEN_50;
                        } else {
                          return 'auto';
                        }
                      })()
                    }}
                  >
                    {headers?.map((header, headerIndex) => (
                      <TableCell
                        style={{
                          padding: 10,
                          textAlign: header.align,
                          overflow: 'hidden',
                          width: header?.width ?? 'auto',
                          maxWidth: header?.width ?? 'auto',
                          minWidth: header?.width ?? 'auto',
                          textOverflow: 'ellipsis',
                          paddingRight: header?.align === 'right' ? 20 : 0
                        }}
                        width={header.width ? header.width : 'auto'}
                        key={headerIndex}
                        align={header.align}
                      >
                        {CustomTableCell(header.id, row)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={count}
            rowsPerPage={filter?.limit}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
            labelRowsPerPage={t('ROWS_PER_PAGE')}
          />
        </Paper>
      </Box>
    );
  }
);

export default BakeasyTable;

export interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

export function TablePaginationActions(props: TablePaginationActionsProps) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
      </IconButton>
    </Box>
  );
}
